import React from 'react';
import styled from 'styled-components/macro';
import { OnPageText } from 'src/client/components/OnPageSeo/OnPageText/OnPageText';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { DescriptionText, HighlightText, BrandedPillButton } from './styles';

import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { useStaticSplashContent } from './content/useStaticSplashContent';

export const Intro = () => {
  const [href] = useJoinUrl({ campaign: 'static-splash-intro' });
  const showSfwSite = useShowSfwSite();

  const { intro } = useStaticSplashContent();
  const buttonText = showSfwSite ? intro.buttonTextNonNude : intro.buttonText;

  return (
    <Wrapper>
      <SeoTitle contentName="text1" />
      <HighlightText>{intro.largeTagline}</HighlightText>
      <DescriptionText>{intro.smallTagline}</DescriptionText>
      <BrandedPillButton as="a" href={href} data-tagmanager-event="join_cta">
        {buttonText}
      </BrandedPillButton>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 10px;
  justify-items: center;
  padding: 10px 0;
  text-align: center;

  @media ${TABLET_PORTRAIT} {
    gap: 20px;
  }

  @media ${DESKTOP} {
    padding-bottom: 40px;
  }
`;

const SeoTitle = styled(OnPageText)`
  font-size: 14px;
  margin-bottom: 10px;

  h2 {
    padding: 0;
  }

  @media ${TABLET_PORTRAIT} {
    margin-bottom: 0;
  }

  @media ${DESKTOP} {
    margin-bottom: 20px;
  }
`;
